import { render } from "./RequiredMark.vue?vue&type=template&id=ee7818e0"
import script from "./RequiredMark.vue?vue&type=script&lang=js"
export * from "./RequiredMark.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__